
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card loading redirect-loading\">\n  <section>\n    <div class=\"spinner\"></div>\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  